import type { SelectProps } from 'core/components';
import { useUpdateUserRoles } from './hooks';
import { RolesSelect } from './RolesSelect';
import type { UserId } from '../../types';
import type { UserRoles } from '../../base';

type UpdateUserRoles = {
  userId: UserId;
  myUserId?: UserId;
  selectProps: SelectProps;
  updateUsersRole: (listIds: UserId[], role: UserRoles[]) => void;
};

export function UpdateUserRoles({ userId, selectProps, updateUsersRole }: UpdateUserRoles) {
  const { mutate: updateUserRole, isError, isLoading } = useUpdateUserRoles();
  const status = isError ? 'error' : '';

  const onChange = (value: UserRoles) => {
    updateUserRole({
      id: userId,
      roles: [value],
    });
    updateUsersRole([userId], [value]);
  };

  return <RolesSelect loading={isLoading} onChange={onChange} status={status} {...selectProps} />;
}
